<template>
  <div class="message-info">{{ $t('QUESTION_FORM.NOT_VOTED') }}</div>
</template>

<script>
export default {
  name: 'question-not-voted'
};
</script>

<style lang="scss" scoped>
.message-info {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
</style>
